export const IFrameWidgetId = 'IFrameWidget';

export enum IFrameWidgetAttributes {
  URL = 'url',
}
